export const NO_CUSOMIZED_PARAM = 'NONE';
export const LOGO_MAKER_STANDALONE_PARAM = 'logo_maker';
export const BUSINESS_CARDS_LOGIN_PARAM = 'bcm';
//# sourceMappingURL=loginCustomizedParams.js.map